import { render, staticRenderFns } from "./DealDocsTemplate.vue?vue&type=template&id=43b2cf9e"
import script from "./DealDocsTemplate.vue?vue&type=script&lang=js"
export * from "./DealDocsTemplate.vue?vue&type=script&lang=js"
import style0 from "./DealDocsTemplate.vue?vue&type=style&index=0&id=43b2cf9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports